import React, { useState, useEffect } from "react";
import "bootstrap";
import { TrainingAPI } from "../../api/TrainingAPI";
import "bootstrap/dist/css/bootstrap.min.css";

import { TeamAvgTable } from "./TeamAvgTable";

import { Navbar } from "../Navigation/Navbar";
import {
	DatePicker,
	Button,
	Space,
	BackTop,
	Popconfirm,
	Switch,
	Tabs,
	Typography,
	Checkbox,
	Col,
	Row,
	Popover,
	Tag,
	Radio,
} from "antd";
import { audioMessage as message } from '../Common/Notifications/audioMessage';
import { FileTwoTone, TruckFilled } from "@ant-design/icons";
import moment from "moment";
import "../../Styles/styles-TeamData.css";
import "../../Styles/styles-PostData.css";
import ForcePlate from "../ForcePlate/ForcePlate";
import TestingData from "../TestingData/TestingData";
import Nutrition from "../Nutrition/Nutrition";
import { Subjective } from "../Subjective/Subjective";
import { isNordicMetric } from "../../Utils/chart_utils";
import {
	custom_fp_metrics,
	fp_metrics,
} from "../../Utils/fp_metrics";
import { useSelector, useDispatch } from "react-redux";
import { DATE_FORMAT } from "../../Utils/date_utils";
import {
	getTeamDrillCostPerMin,
	getLastPracticePlanDate,
	getTeamGPSData,
	getTeamTestingRadarData,
	setTeamFilter,
	changeTeamFPMetric,
	setTeamLoading,
	getTeamMovementSignatureData
} from "../../store/actions/team.actions";
import { useMemo } from "react";
import { LoadingComponent } from "../Common/LoadingComponent";
import { renderAsPDF, downloadBlob } from "../../Utils/pdf_utils";
import { GetWellnessReportButton } from "../Subjective/GetWellnessReportButton";
import { HelpButton } from "../Common/HelpButton";
import { TfiLock } from "react-icons/tfi";
import { audioNotification as notification } from "../Common/Notifications/audioNotification";
import { DataColorUtil } from "../../Utils/color_utils";

const { RangePicker } = DatePicker;
const { TabPane } = Tabs;
const { Text } = Typography;

let trainingAPI = new TrainingAPI();

export const TeamData = (props) => {
	const dispatch = useDispatch();
	const {
		loading: { gps: loading },
		games,
		positions,
		playerGroups,
		hasWellness,
		trainings,
		fpmsData,
		fpMetrics,
		forceplateStatDefaults,
		all_metric_types: allMetricTypes,
		info: {
			display_name: teamName,
			coach_list,
			sessions: session_list,
			hideDistanceZones,
			team_colors,
			movement_sig_chart_mapping,
			dataviz_lite: datavizLite,
			sport: sport
		},
		filter: {
			showGameDays,
			showPredictions,
			showWeekly,
			startDate,
			endDate,
			position,
			player_group,
			session,
			testingStats,
		},
		color_strategies: colorStrategies,
	} = useSelector(({ team }) => team);
	const { testingData, testingStatDefaults, info } = useSelector(
		({ team }) => team
	);

	const [dataColorUtil, setDataColorUtil] = useState(null);

	useEffect(() => {
		if (trainings?.colors && trainings?.metrics?.length && colorStrategies?.length) {
			setDataColorUtil(new DataColorUtil({
				teamName,
				gpsBaselines: trainings.colors, // using colors as baselines
				teamGpsMetrics: trainings.metrics,
				colorStrategies
			}));
		} else {
			setDataColorUtil(null);
		}
	}, [trainings?.colors, trainings?.metrics, teamName, colorStrategies]);

	const {
		currentUser: { email: currentUserEmail },
	} = useSelector(({ auth }) => auth);

	const [activeTab, setActiveTab] = useState("1");
	const [exportPreview, setExportPreview] = useState(false);
	const [selectedEmails, setSelectedEmails] = useState({});
	const [groupByPos, setGroupByPos] = useState(false);
	const [gpsReportType, setGPSReportType] = useState(null);
	const [rendering, setRendering] = useState(false);
	const [showTravel, setShowTravel] = useState(false);
	const [showRest, setShowRest] = useState(false);
	const [showACWR, setShowACWR] = useState(false);
	const [nutritionReportDates, setNutritionReportDates] = useState([startDate, endDate]);
	const [prePostBWReportDate, setPrePostBWReportDate] = useState(moment(endDate));
	const [bodyWeightReportWeekly, setBodyWeightReportWeekly] = useState(false);
	const [gpsDailyDistanceReportDates, setGPSDailyDistanceReportDates] = useState([moment().subtract(6, "days").format("YYYY-MM-DD"), endDate]);
	const [gpsWeeklyDistanceReportDates, setGPSWeeklyDistanceReportDates] = useState([moment().subtract(4, "weeks").format("YYYY-MM-DD"), endDate]);

	useEffect(() => {
		dispatch(getTeamDrillCostPerMin());
		if (custom_fp_metrics[teamName]) {
			custom_fp_metrics[teamName].map((val, i) => {
				dispatch(changeTeamFPMetric(i, val));
			});
		}
	}, []);

	useEffect(() => {
		handleSearch();
	}, [activeTab]);

	const onChangeEmailSelection = (option) => {
		setSelectedEmails((prev) => ({
			...prev,
			[option]: !prev[option],
		}));
	};

	const handleSearch = async () => {
		if (!startDate || !endDate) {
			message.error("Please select valid date range to retrieve training data.");
			return;
		}

		if (activeTab === "1" || activeTab === "2") {
			dispatch(getTeamGPSData());
		} else if (activeTab === "3") {
			if (movement_sig_chart_mapping !== null) {
				dispatch(getTeamMovementSignatureData());
			}
			dispatch(getTeamTestingRadarData())
		} else if (activeTab === "4") {
			dispatch(getTeamTestingRadarData())
		}
	};

	const handleToggleShowGame = (checked) => {
		dispatch(setTeamFilter({ showGameDays: checked }));
	};

	const onToggleGPSReportType = (checked) => {
		setGPSReportType(checked);
	};

	const onToggleGroupByPos = (checked) => {
		setGroupByPos(!groupByPos);
	};

	const handleTogglePredictions = async (checked) => {
		dispatch(setTeamFilter({ showPredictions: checked }));
		if (checked) {
			const lastPracticePlanDate = await getLastPracticePlanDate();

			let endDate = moment().add(7, "days").format("YYYY-MM-DD");
			let today = moment().format("YYYY-MM-DD");
			if (endDate > lastPracticePlanDate) endDate = lastPracticePlanDate;
			if (endDate < today) endDate = today;

			dispatch(setTeamFilter({ endDate }));
			dispatch(getTeamGPSData());
		} else {
			dispatch(setTeamFilter({ endDate: moment().format(DATE_FORMAT) }));
		}
	};

	const handleWeeklyToggle = (checked) => {
		if (checked) {
			dispatch(setTeamFilter({ showGameDays: false }));
		}
		dispatch(setTeamFilter({ showWeekly: checked }));
	};

	const handlePositionChange = (value) => {
		if (position.includes(value)) {
			dispatch(
				setTeamFilter({
					position: position.filter((pos) => pos !== value),
				})
			);
		} else {
			dispatch(setTeamFilter({ position: [...position, value] }));
		}
	};

	const handlePlayerGroupChange = (value) => {
		if (player_group.includes(value)) {
			dispatch(setTeamFilter({ player_group: player_group.filter((pos) => pos !== value) }));
		} else {
			dispatch(setTeamFilter({ player_group: [...player_group, value] }));
		}
	};

	const handleSessionChange = (value) => {
		if (session.includes(value)) {
			dispatch(setTeamFilter({ session: session.filter((pos) => pos !== value) }));
		} else {
			dispatch(setTeamFilter({ session: [...session, value] }));
		}
	};

	const handleDateRangeChange = (value, dateString) => {
		dispatch(
			setTeamFilter({ startDate: dateString[0], endDate: dateString[1] })
		);
	};

	const gameDates = useMemo(
		() =>
			trainings?.data?.reduce(
				(cur, data) => ({ ...cur, [data.date]: data.opponent }),
				{}
			),
		[trainings]
	);

	const filteredData = useMemo(
		() =>
			showGameDays && trainings?.data
				? {
					...trainings,
					data: trainings?.data?.filter((data) => {
						if (data.opponent) gameDates[data.date] = true;
						return data.opponent;
					}),
					wellness: Object.keys(trainings?.wellness || {}).reduce(
						(cur, key) => ({
							...cur,
							[key]: trainings?.wellness?.[key]?.filter(
								(data) => gameDates[data.date]
							),
						}),
						{}
					),
				}
				: trainings,
		[trainings, gameDates, showGameDays]
	);

	const onGetNutritionReport = async () => {
		try {
			// Check date range for weekly reports (max 12 weeks = 84 days)
			if (bodyWeightReportWeekly) {
				const startDate = moment(nutritionReportDates[0]);
				const endDate = moment(nutritionReportDates[1]);
				const daysDiff = endDate.diff(startDate, 'days');
				
				if (daysDiff > 84) {
					console.log(`Date range error for nutrition report: ${nutritionReportDates[0]} to ${nutritionReportDates[1]}, weekly: ${bodyWeightReportWeekly}, days: ${daysDiff}`);
					message.error("Date range cannot exceed 12 weeks for weekly body weight reports");
					return;
				}
			}

			message.info("Generating report for the selected date range");

			if (['weekly-bw-breakdown', 'one-pager-bw'].includes(bodyWeightReportWeekly)) {
				await trainingAPI.getBWReportPDF(nutritionReportDates[0], nutritionReportDates[1], 
					bodyWeightReportWeekly === 'weekly-bw-breakdown')
				.then((res) => {
					const fileName = bodyWeightReportWeekly 
						? `Body Weight Weekly Breakdown ${nutritionReportDates[0]} - ${nutritionReportDates[1]}.pdf`
						: `Body Weight One Pager ${nutritionReportDates[0]} - ${nutritionReportDates[1]}.pdf`;
					downloadBlob(res.data, fileName);
				})
				.catch((err) => {
					console.log(err);
					message.error("Error generating report")
				});
			} else if (bodyWeightReportWeekly === 'bw-analysis'){
				const reportDate = prePostBWReportDate.format("YYYY-MM-DD")
				await trainingAPI.emailPrePostBodyWeightReport(
					reportDate,
					position,
					player_group)
				.then((res) => {
					downloadBlob(res.data, `Pre/Post Body Weight Analysis Report - ${reportDate}.pdf`)
				})
				.catch((err) => {
					if (typeof err === "string") {
						message.error(err)
					} else {
						message.error("Error generating report")
					}
				});
			}
			
		} catch (e) {
			console.log(e);
			message.error("Error generating report")
		}
	};

	const onGetFPReport = async () => {
		let emails = Object.keys(selectedEmails).filter(
			(key) => selectedEmails[key] === true
		);
		if (emails.length === 0) {
			message.info(
				"Please select at least one email recipient for the report"
			);
			return;
		}

		let metrics = Array.from(
			document.getElementsByClassName("forceplate-stat-tile")
		)
			.map((el) => el.getAttribute("itemx"))
			.filter((x) => x);
		let agg = testingStats === true ? "Max" : "Avg";
		let comparison = Array.from(
			document.getElementsByClassName("forceplate-stat-comparison")
		).map((el) => el.getAttribute("itemx"))?.[0];

		if (new Set(metrics).size < metrics.length) {
			message.info("Please select 4 metrics without any duplicates");
			return;
		}

		if (metrics.length < 4) {
			message.info(
				"Please select and save 4 metrics on the tiles below to be included in the report"
			);
			return;
		}
		try {
			message.info("Generating report");
			const res = await trainingAPI.emailForcePlateReport({
				date: endDate,
				agg: agg,
				comparison: comparison,
				metrics,
				emails,
				position,
				player_group,
				group_by_position: groupByPos,
				sessions: session
			});
			if (res === "Done") {
				message.success("The report has been sent to your email");
			} else {
			}
		} catch (e) {
			if (e === "The report will be sent shortly.") {
				message.info(e);
			} else {
				message.error("Error generating report")
			}
		}
	};

	const onGetTestingReport = async () => {
		let emails = Object.keys(selectedEmails).filter(
			(key) => selectedEmails[key] === true
		);
		if (emails.length === 0) {
			message.info(
				"Please select at least one email recipient for the report"
			);
			return;
		}

		let metrics = Array.from(
			document.getElementsByClassName("testing-stat-tile")
		)
			.map((el) => el.getAttribute("itemx"))
			.filter((x) => x);
		let agg = testingStats === true ? "Max" : "Avg";
		let comparison = Array.from(
			document.getElementsByClassName("testing-stat-comparison")
		).map((el) => el.getAttribute("itemx"))?.[0];

		if (new Set(metrics).size < metrics.length) {
			message.info("Please select 4 metrics without any duplicates");
			return;
		}

		if (metrics.length < 4) {
			if (teamName === "FAU Football" && metrics.length >= 1) {
				// pass
			} else if (
				metrics
					.map(
						(x) =>
							x.includes(":") && isNordicMetric(x.split(":")[0])
					)
					.every(Boolean)
			) {
				metrics = metrics.map((x) => x.split(":")[0]);
			} else {
				message.info(
					"Please select and save 4 metrics on the tiles below to be included in the report"
				);
				return;
			}
		}
		try {
			message.info("Generating report");
			const res = await trainingAPI.emailTestingReport({
				date: endDate,
				agg,
				comparison,
				metrics,
				emails,
				position,
				player_group,
				groupByPos,
				group_by_position: groupByPos,
				sessions: session
			});
			if (res === "Done") {
				message.success("The report has been sent to your email");
			} else {
			}
		} catch (e) {
			if (e === "The report will be sent shortly.") {
				message.info(e);
			} else {
				message.error("Error generating report")
			}
		}
	};

	const onGetGPSReport = async () => {
		let emails = Object.keys(selectedEmails).filter(
			(key) => selectedEmails[key] === true
		);
		if (emails.length === 0) {
			message.info(
				"Please select at least one email recipient for the report"
			);
			return;
		}

		try {
			message.info("Generating report");
			let res;
			if (gpsReportType === "daily-distances") {
				res = await trainingAPI.emailDistanceReport(
					gpsDailyDistanceReportDates[0],
					gpsDailyDistanceReportDates[1],
					emails,
					"single_week",
					position,
					player_group);
			} else if (gpsReportType === "weekly-distances") {
				res = await trainingAPI.emailDistanceReport(
					gpsWeeklyDistanceReportDates[0],
					gpsWeeklyDistanceReportDates[1],
					emails,
					"multi_week",
					position,
					player_group);
			} else if (gpsReportType === "acwr-analysis") {
				res = await trainingAPI.emailACWRAnalysisReport(
					endDate,
					emails,
					position,
					player_group,
					session);
			} else {
				res = await trainingAPI.emailGPSReport(endDate, emails, session, player_group, position, gpsReportType === "coach");
			}

			if (res === "Done") {
				message.success("The report has been sent to your email");
			} else {
				if (res.includes("No data found")) {
					const lines = res.split("\n");
					const title = lines[0];
					const rest = lines.slice(1, lines.length).join("\n");

					notification.warning({
						message: title,
						description: (<div className="multiline-message" style={{ whiteSpace: 'pre-line', textAlign: 'left' }}>{rest}</div>),
						placement: 'top',
						style: {
							width: '20rem'
						},
						duration: 10
					})
				}
			}
		} catch (e) {
			console.log(e)
			if (e === "The report will be sent shortly.") {
				message.info(e);
			} else if (typeof e == 'string' && e.length < 100){
				message.error(e)
			} else {
				message.error("Error generating report")
			}
		}
	};

	const popConfirmText = (
		<>
			<Text>
				Would you like to generate a detailed report?
				<br />
				{activeTab === "4" || activeTab === "3" ? (
					<>
						<Checkbox
							style={{ marginBottom: "0.5em" }}
							checked={groupByPos}
							onChange={onToggleGroupByPos}
						>
							Group By Position
						</Checkbox>
					</>
				) : null}
				{activeTab === "1" ? (
					<>
						<Radio.Group onChange={e => onToggleGPSReportType(e.target.value)} value={gpsReportType}>
							<Radio value="coach">Coach's Report - Short and to the point</Radio><br></br>
							<Radio value="full">Full Report - Detailed Analysis</Radio><br></br>
							{
								teamName === "Las Vegas Raiders" ? (
									<>
									<Radio value="daily-distances">Single Week Distance Breakdown Report</Radio><br></br>
									<Radio value="weekly-distances">Multi Week Distance Breakdown Report</Radio><br></br>
									<Radio value="acwr-analysis">ACWR Analysis Report</Radio><br></br>
									</>
								) : null
							}
							
						</Radio.Group>
					</>
				) : null}
			</Text>

			{
				gpsReportType === "daily-distances" ?
				 <>
				<div style={{ margin: "0.5em" }}>
					Please select the dates to be included in the report: <br />
					<Text type="secondary" style={{fontSize: 11}}>(Max 7 days)</Text>
					<br/>
					<DatePicker.RangePicker
						style={{borderRadius: '2px', marginTop: '5px'}}
						onChange={(value, dateString) => {setGPSDailyDistanceReportDates([dateString[0], dateString[1]]);}}
						value={[
							!gpsDailyDistanceReportDates[0] ? null : moment(gpsDailyDistanceReportDates[0]),
							!gpsDailyDistanceReportDates[1] ? null : moment(gpsDailyDistanceReportDates[1]),
						]}
						allowClear={false} />
				</div>
				</> : null
			}
			{
				gpsReportType === "weekly-distances" ?
				 <>
				 <br />
				<div style={{ margin: "0.5em" }}>
					Please select the dates to be included in the report: <br />
					<Text type="secondary" style={{fontSize: 11}}>(Max 7 weeks)</Text>
					<br/>
					<DatePicker.RangePicker
						style={{borderRadius: '2px', marginTop: '5px'}}
						onChange={(value, dateString) => {setGPSWeeklyDistanceReportDates([dateString[0], dateString[1]]);}}
						value={[
							!gpsWeeklyDistanceReportDates[0] ? null : moment(gpsWeeklyDistanceReportDates[0]),
							!gpsWeeklyDistanceReportDates[1] ? null : moment(gpsWeeklyDistanceReportDates[1]),
						]}
						allowClear={false} />
				</div>
				</> : null
			}

			<hr />
			<div style={{ marginTop: "0.5em" }}>
				Please select the emails that should receive the report:
			</div>

			<Col style={{ marginTop: "0.5em" }}>
				{coach_list
					.filter((x) => x.email == currentUserEmail)
					.map((item) => (
						<Row>
							<Checkbox
								checked={selectedEmails[item.email] || false}
								onChange={() => onChangeEmailSelection(item.email)}
							>
								{item.first_name} {item.last_name}{" "}
								<span style={{ fontSize: 13 }}>({item.email})</span>
							</Checkbox>
						</Row>
					))}
				{coach_list
					.filter((x) => x.email != currentUserEmail)
					.map((item, index) => (
						<Row key={index}>
							<Checkbox
								checked={selectedEmails[item.email] || false}
								onChange={() => onChangeEmailSelection(item.email)}
							>
								{item.first_name} {item.last_name}{" "}
								<span style={{ fontSize: 13 }}>({item.email})</span>
							</Checkbox>
						</Row>
					))}
			</Col>
		</>
	);

	const nutritionPopConfirmText = (
		<>
			<div>
				
				<Text strong>Would you like to generate a Body Weight Report?</Text>

				<Radio.Group
					style={{ margin: '5px 0px', display: "flex", flexDirection: "column" }}
					onChange={(e) => setBodyWeightReportWeekly(e.target.value)}
					value={bodyWeightReportWeekly}
					options={[
						{ label: 'One Pager Report', value: 'one-pager-bw' },
						{ label: 'Weekly Breakdown Report', value: 'weekly-bw-breakdown' },
						{ label: 'Pre/Post BW Analysis Report', value: 'bw-analysis' },
					]}
				/>
				<Text>Pick a date for the report:</Text>
				{
					bodyWeightReportWeekly !== 'bw-analysis' && (
						<>
							<br />
							<RangePicker
								style={{borderRadius: '2px', marginTop: '5px'}}
								onChange={(value, dateString) => {setNutritionReportDates([dateString[0], dateString[1]]);}}
								value={[
									!nutritionReportDates[0] ? null : moment(nutritionReportDates[0]),
									!nutritionReportDates[1] ? null : moment(nutritionReportDates[1]),
								]}
								allowClear={false} 
							/>
						</>
					)
				}
				{
					bodyWeightReportWeekly === 'bw-analysis' && (
						<>
							<br />
							<DatePicker
								style={{borderRadius: '2px', marginTop: '5px'}}
								defaultValue={prePostBWReportDate}
								allowClear={false} 
								onChange={(dateString) => {prePostBWReportDate(dateString);}}
							/>
						</>
					)
				}

		</div>

		</>
	);

	const handleChangeFPMetrics = (key, value) => {
		dispatch(changeTeamFPMetric(key, value));
	};

	const handleDownloadPDF = async () => {
		setRendering(true);
		setExportPreview(true);

		let descString = `Date Range: ${startDate} - ${endDate}`;
		if (position) descString = descString + ` | Position: ${position}`;
		if (player_group)
			descString = descString + ` | Player Group : ${player_group}`;
		if (session) descString = descString + ` | Session : ${session}`;

		await new Promise((r) => setTimeout(r, 300));

		let chartDOMs = [],
			columns = 2,
			widget = null,
			table = null;
		table = document.getElementsByTagName("table")[0];

		if (activeTab === "1") {
			chartDOMs = document.getElementsByClassName("example-table-graph");
		}
		if (activeTab === "2") {
			columns = 1;
			table = null;
			chartDOMs = document.getElementsByClassName("tab-subjective");
		}
		if (activeTab === "3") {
			table = null;
			chartDOMs = document.getElementsByClassName("fp-testing-chart");
		}
		if (activeTab === "4") {
			chartDOMs = document.getElementsByClassName("fp-testing-chart");
		}


		await renderAsPDF({ header: descString, columns, widget, table, chartDOMs });

		setExportPreview(false);
		setRendering(false);
	};

	const DaysOptionsContent = () => {
		return (
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					justifyContent: "center",
					gap: 16,
					width: 140,
				}}
			>
				{activeTab === "1" && (
					<>
						<Switch
							onChange={setShowACWR}
							checked={showACWR}
							checkedChildren="Per Minute"
							unCheckedChildren="ACWR"
						/>
					</>
				)}
				{(activeTab === "1" || activeTab === "2") && (
					<>
						<Switch
							onChange={setShowTravel}
							checked={showTravel}
							checkedChildren="Hide Travel Days"
							unCheckedChildren="Show Travel Days"
						/>
						<Switch
							onChange={setShowRest}
							checked={showRest}
							checkedChildren="Hide Rest Days"
							unCheckedChildren="Show Rest Days"
						/>
					</>
				)}
				{activeTab !== "4" && (
					<Switch
						onChange={handleToggleShowGame}
						checked={showGameDays}
						checkedChildren="Game Days"
						unCheckedChildren="All Days"
					/>
				)}
				{activeTab !== "2" && activeTab !== "4" && (
					<Switch
						onChange={handleWeeklyToggle}
						checked={showWeekly}
						checkedChildren="Weekly"
						unCheckedChildren="Daily"
					/>
				)}
			</div>
		);
	};

	const checkableTagStyle = {
		border: "1px solid #1890ff",
		borderRadius: 4,
	};

	const SelectionOptionsContent = () => {
		return (
			<>
				<div
					style={{
						display: "flex",
						flexWrap: "wrap",
						gap: 10,
						width: "100%",
						justifyContent: "center",
					}}
				>
					{activeTab !== "5" ? <>
						{positions && !!positions.length && (
							<div
								style={{
									overflowX: "auto",
									maxWidth: "40%",
									display: "flex",
									flexDirection: "row",
									gap: "5px",
								}}
							>
								<strong>Positions: </strong>
								<div
									style={{
										overflowX: "auto",
										paddingBottom: "5px",
										whiteSpace: "nowrap",
									}}
									className="customScroll"
								>
									{positions.map((pos, i) => (
										<Tag.CheckableTag
											style={checkableTagStyle}
											key={i}
											checked={position?.includes(pos)}
											onChange={() =>
												handlePositionChange(pos)
											}
										>
											{pos}
										</Tag.CheckableTag>
									))}
								</div>
							</div>
						)}
						{playerGroups && !!playerGroups.length && (
							<div
								style={{
									overflowX: "auto",
									maxWidth: "40%",
									display: "flex",
									gap: "5px",
								}}
							>
								<strong>Player Groups: </strong>
								<div
									style={{
										overflowX: "auto",
										paddingBottom: "5px",
										whiteSpace: "nowrap",
									}}
									className="customScroll"
								>
									{playerGroups.map((group, i) => (
										<Tag.CheckableTag
											style={checkableTagStyle}
											key={i}
											checked={player_group?.includes(group.player_group_id)}
											onChange={() =>
												handlePlayerGroupChange(group.player_group_id)
											}
										>
											{group.name}
										</Tag.CheckableTag>
									))}
								</div>
							</div>
						)}</> : null}
					{session_list && !!session_list.length && (
						<div
							style={{
								overflowX: "auto",
								maxWidth: "fit-content",
								display: "flex",
								flexDirection: "row",
								gap: "5px",
							}}
						>
							<strong>Sessions: </strong>
							<div
								style={{
									maxWidth: "100%",
									overflowX: "auto",
									paddingBottom: "5px",
									whiteSpace: "nowrap",
								}}
								className="customScroll"
							>
								{session_list.map((sess, i) => (
									<Tag.CheckableTag
										style={checkableTagStyle}
										key={i}
										checked={session?.includes(sess)}
										onChange={() =>
											handleSessionChange(sess)
										}
									>
										{sess}
									</Tag.CheckableTag>
								))}
							</div>
						</div>
					)}
				</div>
			</>
		);
	};

	const techStreamExists = (tab) => {
		if (tab === "gps" && datavizLite) return false; // hide GPS for dataviz_lite users
		return allMetricTypes[tab]?.length > 0;
	}

	const customTabPane = ({ key, label }) => {
		return (
			<span
				style={{ display: 'flex', alignItems: 'center' }}
			>
				{label} {!techStreamExists(key) && <TfiLock style={{ marginLeft: 2 }} />}
			</span>
		)
	}

	const getFirstTabToDisplay = () => {
		const tabs = ['gps', 'wellness', 'forceplate', 'testing', 'nutrition'];
		for (let i = 0; i < tabs.length; i++) {
			if (techStreamExists(tabs[i])) {
				return {
					"gps": "1",
					"wellness": "2",
					"forceplate": "3",
					"testing": "4",
					"nutrition": "5"
				}[tabs[i]];
			}
		}
		return "1"
	}

	useEffect(() => {
		// this is needed to update the activeTab state variable once all data is loaded
		setActiveTab(getFirstTabToDisplay());
	}, []);

	const nutritionReportIsAvailable = () => {

		if (teamName === "Las Vegas Raiders") return true;

		if (teamName.startsWith("Demo Team -") && (sport === 'football')) return true;

		return false;
	}

	return (
		<>
			<Navbar />
			<HelpButton page="Team" />
			<div className="teamdata-content">
				<BackTop />
				<div className="search-divider"></div>
				<div
					style={{
						alignItems: "center",
						display: "flex",
						flexDirection: "column",
						width: "100%",
						gap: 16,
					}}
				>
					<Space>
						<RangePicker
							onChange={handleDateRangeChange}
							value={[
								!startDate ? null : moment(startDate),
								!endDate ? null : moment(endDate),
							]}
							style={{ width: 250 }}
						/>
						<Popover
							content={<DaysOptionsContent />}
							title="Day Options"
							trigger="click"
						>
							<Button>Options</Button>
						</Popover>
						{activeTab !== "4" && (
							<Switch
								onChange={handleTogglePredictions}
								checked={showPredictions}
								checkedChildren="Hide Predictions"
								unCheckedChildren="Show Predictions"
							/>
						)}
						<Button type="primary" onClick={handleSearch}>
							Search
						</Button>

						{activeTab === "1" ? (
							<Popconfirm
								placement="bottom"
								title={popConfirmText}
								icon={<FileTwoTone />}
								onConfirm={onGetGPSReport}
								okText="Yes"
								cancelText="No"
							>
								<Button>Get Report</Button>
							</Popconfirm>
						) : null}

						{activeTab === "2" ? (
							<GetWellnessReportButton />
						) : null}

						{activeTab === "3" ? (
							<Popconfirm
								placement="bottom"
								title={popConfirmText}
								icon={<FileTwoTone />}
								onConfirm={onGetFPReport}
								okText="Yes"
								cancelText="No"
							>
								<Button>Get Report</Button>
							</Popconfirm>
						) : null}

						{activeTab === "4" ? (
							<Popconfirm
								placement="bottom"
								title={popConfirmText}
								icon={<FileTwoTone />}
								onConfirm={
									activeTab === "3"
										? onGetFPReport
										: onGetTestingReport
								}
								okText="Yes"
								cancelText="No"
							>
								<Button>Get Report</Button>
							</Popconfirm>
						) : null}

						{activeTab === "5" && (nutritionReportIsAvailable()) ? (
							<Popconfirm
								placement="bottom"
								title={nutritionPopConfirmText}
								icon={<FileTwoTone />}
								onConfirm={onGetNutritionReport}
								okText="Yes"
								cancelText="No"
							>
								<Button>Get Report</Button>
							</Popconfirm>
						) : null}

						<Button
							loading={rendering}
							type="primary"
							onClick={() => {
								handleDownloadPDF();
							}}
						>
							Export as PDF
						</Button>
					</Space>
					<div
						style={{
							width: "75%",
							overflowX: "auto",
							textAlign: "-webkit-center",
						}}
					>
						<SelectionOptionsContent />
					</div>
				</div>
				<br />
				{/* <br /> */}

				<Tabs
					defaultActiveKey={getFirstTabToDisplay()}
					type="card"
					onChange={setActiveTab}
					centered
				>
					<TabPane
						tab={customTabPane({ key: "gps", label: "GPS" })}
						key="1"
						disabled={!techStreamExists("gps")}
					>
						<LoadingComponent
							loading={rendering}
							title="Rendering to PDF file..."
						>
							{!!trainings && activeTab === "1" && (
								<TeamAvgTable
									showACWR={showACWR}
									showTravel={showTravel}
									showRest={showRest}
									data={filteredData}
									hideDistanceZones={hideDistanceZones}
									showAll={exportPreview}
									type="team"
									dataColorUtil={dataColorUtil}
								/>
							)}
						</LoadingComponent>
					</TabPane>
					<TabPane
						tab={customTabPane({ key: "wellness", label: "Wellness" })}
						key="2"
						id="wellness"
						disabled={!techStreamExists("wellness")}
					>
						{trainings !== undefined && activeTab === "2" ? (
							<LoadingComponent
								loading={rendering}
								title="Rendering to PDF file..."
							>
								<Subjective
									data={filteredData}
									loading={loading}
									allGames={games}
									showAll={exportPreview}
									showRestTravelOptions={{
										showTravel,
										showRest,
										startDate,
										endDate,
									}}
									type="team"
								/>
							</LoadingComponent>
						) : (
							<p>No data for your query.</p>
						)}
					</TabPane>
					<TabPane
						tab={customTabPane({ key: "forceplate", label: "Force Plate" })}
						key="3"
						id="fp"
						disabled={!techStreamExists("forceplate")}
					>
						{activeTab === "3" && (
							<LoadingComponent
								loading={rendering}
								title="Rendering to PDF file..."
							>
								<ForcePlate
									data={{
										...fpmsData,
										data: fpmsData?.data?.sort((a, b) =>
											a.date < b.date ? -1 : 1
										),
									}}
									movement_sig_chart_mapping={movement_sig_chart_mapping}
									metrics={fpMetrics}
									fp_change_metric={handleChangeFPMetrics}
									team_name={teamName}
									position_filter={position}
									type="team"
								/>
							</LoadingComponent>
						)}
					</TabPane>
					<TabPane
						tab={customTabPane({ key: "testing", label: "Testing" })}
						key="4"
						id="testing"
						disabled={!techStreamExists("testing")}
					>
						{activeTab === "4" && (
							<LoadingComponent
								loading={rendering}
								title="Rendering to PDF file..."
							>
								<TestingData
									showAll={exportPreview}
									position_filter={position}
									type="team"
								/>
							</LoadingComponent>
						)}
					</TabPane>
					<TabPane
						tab={customTabPane({ key: "nutrition", label: "Nutrition" })}
						key="5"
						id="nutrition"
						disabled={!techStreamExists("nutrition")}
					>
						{activeTab === "5" && (
							<LoadingComponent
								loading={rendering}
								title="Rendering to PDF file..."
							>
								<Nutrition
									showAll={exportPreview}
									position_filter={position}
									type="team"
								/>
							</LoadingComponent>
						)}
					</TabPane>
				</Tabs>
			</div>
		</>
	);
};

export default TeamData;
